import { useCallback, useMemo } from 'react';
import { useActiveCompanyId } from '~/hooks/useActiveCompany';
import { useAnalyticsContext } from '~/hooks/useAnalyticsContext';
import { AnalyticsEvents } from '~/services/analytics';
import { useLoggedUser } from '~/services/user';
import { EventProps, page, track } from './segment';
import { useCompany } from './useCompany';

export const useAnalytics = () => {
  const companyId = useActiveCompanyId();
  const { data: company } = useCompany(companyId);
  const user = useLoggedUser();
  const context = useAnalyticsContext();

  const trackEvent = useCallback(
    (eventName: AnalyticsEvents, additionalProperties?: EventProps) => {
      // A manual internal `context` intentionally overrides the provider context for one event.
      track(eventName, user.data, company, { context, ...additionalProperties });
    },
    [company, user.data, context],
  );

  const pageEvent = useCallback(
    (additionalProperties?: EventProps) => {
      page(user.data, company, additionalProperties);
    },
    [company, user.data],
  );

  return useMemo(() => ({ track: trackEvent, page: pageEvent }), [pageEvent, trackEvent]);
};
